import { Table } from "antd";

/**
 * Global guard cho antd Table.
 *
 * Vấn đề: nhiều endpoint CMS trả dữ liệu phân cấp kèm field `children`
 * (permissions, menus, categories, products...). antd Table mặc định
 * `childrenColumnName = "children"` -> khi BẤT KỲ dòng nào có field `children`,
 * Table tự bật chế độ tree/nest (InternalTable: rawData.some(i => i[childrenColumnName])).
 * Ở môi trường có dữ liệu thật, nhánh nest này crash:
 *   "Cannot read properties of undefined (reading 'length')".
 * Local DB rỗng nên không dòng nào có children -> không lộ lỗi.
 *
 * Toàn bộ Table trong CMS hiển thị PHẲNG (cây đã được tự làm phẳng trước khi
 * đưa vào dataSource), không màn nào dùng antd tree-expand qua `children`.
 * Vì vậy đặt mặc định `childrenColumnName` = một khóa không tồn tại để Table
 * không bao giờ tự vào nest mode.
 *
 * - Bảng nào truyền `childrenColumnName` riêng vẫn override mặc định này.
 * - Bảng dùng `expandable.expandedRowRender` (expand tùy biến) KHÔNG bị ảnh hưởng
 *   vì nhánh đó là expandType = "row", độc lập với childrenColumnName.
 */
const NO_TREE = "__no_children__";

if (Table) {
  if (!Table.defaultProps) Table.defaultProps = {};
  if (Table.defaultProps.childrenColumnName === undefined) {
    Table.defaultProps.childrenColumnName = NO_TREE;
  }
}
